var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('h1',{staticClass:"title"},[_vm._v("All Recipes")]),_c('RecipeList',{attrs:{"recipes":_vm.recipes,"showCategories":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }